import { render, staticRenderFns } from "./selectConsultants.vue?vue&type=template&id=4f12401e&scoped=true"
import script from "./selectConsultants.vue?vue&type=script&lang=js"
export * from "./selectConsultants.vue?vue&type=script&lang=js"
import style0 from "./selectConsultants.vue?vue&type=style&index=0&id=4f12401e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f12401e",
  null
  
)

export default component.exports